module.exports = __webpack_public_path__ + "img/natuerlich_thumbnail_mobile.5d4ea787.jpg";